import React from 'react';
import { useReduxAction } from '@engage/redux';
import { flushCurrentBatches } from '@engage/video';
import { bufferingMetricsV2, MAXIMUM_DELAY_TIME } from '@members/pg-video/sagas';
import { useStartedClientSession } from './useStartedClientSession';
import useTrackFirstFreemiumSession from './useTrackFirstFreemiumSession';

export const BootupEvents: React.FC<React.PropsWithChildren<unknown>> = () => {
  const flushBatches = useReduxAction(flushCurrentBatches);
  const bufferMetrics = useReduxAction(bufferingMetricsV2);

  React.useEffect(() => {
    // attempt to send any old persisted metrics
    // set delay time to maximum so batches get cleared
    // regardless of success or failure
    flushBatches();
    bufferMetrics(true, MAXIMUM_DELAY_TIME);
  }, []);

  useTrackFirstFreemiumSession();
  useStartedClientSession();
  return null;
};
